import { cn } from '@/lib/utils';

interface ToggleProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
  className?: string;
}

/**
 * Pill toggle switch matching the Barita profile design (44×24 track, 24px knob).
 * Off = gray track, knob left; On = ink track, knob right.
 */
export function Toggle({ checked, onChange, label, className }: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      onClick={() => onChange(!checked)}
      className={cn(
        'relative inline-flex h-[24px] w-[44px] shrink-0 items-center rounded-full transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-barita-ink/40',
        checked ? 'bg-barita-ink' : 'bg-[#9fa5ab]',
        className,
      )}
    >
      <span
        className={cn(
          'inline-block h-[20px] w-[20px] transform rounded-full bg-white shadow transition-transform',
          checked ? 'translate-x-[22px]' : 'translate-x-[2px]',
        )}
      />
    </button>
  );
}
